<template>
  <div v-loading="isLoading" class="comp-tree">
    <el-button
      class="comp-tr-top"
      type="primary"
      size="small"
      @click="handleAddTop"
      >添加顶级节点</el-button
    >
    <!--tree-->
    <el-tree
      ref="SlotTree"
      :props="treeSelectProps"
      :data="setTree"
      :expand-on-click-node="false"
      highlight-current
      default-expand-all
      :node-key="NODE_KEY"
    >
      <div class="comp-tr-node" slot-scope="{ node, data }">
        <!--编辑状态-->
        <template v-if="node.isEdit">
          <el-input
            v-model="data.typeName"
            autofocus
            size="mini"
            :ref="'slotTreeInput' + data[NODE_KEY]"
            @blur.stop="handleInput(node, data)"
            @keyup.enter.native="handleInput(node, data)"
          ></el-input>
        </template>

        <!--非编辑状态-->
        <template v-else>
          <!--名称：新增节点增加class（is-new）-->
          <span
            :class="[
              data[NODE_KEY] < NODE_ID_START ? 'is-new' : '',
              'comp-tr-node--name',
            ]"
          >
            {{ node.label }}
          </span>

          <!--按钮-->
          <span class="comp-tr-node--btns">
            <!--新增-->
            <el-button
              icon="el-icon-plus"
              size="mini"
              circle
              type="primary"
              @click="handleAdd(node, data)"
            ></el-button>

            <!--编辑-->
            <el-button
              icon="el-icon-edit"
              size="mini"
              circle
              type="info"
              @click="handleEdit(node, data)"
            ></el-button>

            <!--删除-->
            <el-button
              icon="el-icon-delete"
              size="mini"
              circle
              type="danger"
              @click="handleDelete(node, data)"
            ></el-button>
          </span>
        </template>
      </div>
    </el-tree>
    <div style="text-align: right;">
      <el-button @click="handleClose" type="primary" size="small"
        >确 定</el-button
      >
    </div>
  </div>
</template>

<script>
import {
  getImgMapTypeSelect,
  addImgMapType,
  editImgMapType,
  deleteImgMapType,
} from "@/api/customProduct/imageStore"
export default {
  name: "component-tree",
  data() {
    return {
      treeSelectProps: {
        value: "typeId", // ID字段名
        label: "typeName", // 显示名称
        children: "childrenTree", // 子级字段名
      }, // 图片分类
      isLoading: false, //是否加载
      setTree: [], //tree数据
      NODE_KEY: "typeId", //id对应字段
      MAX_LEVEL: 3, //设定最大层级
      NODE_ID_START: 0, //新增节点id，逐次递减
      startId: null,
      initParam: {
        //新增参数
        typeName: "新增节点",
        pTypeId: 0,
        childrenTree: [],
      },
      deleteTypeIds: [],
      addObject: {},
      editObject: {},
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '01'
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.getImgMapTypeSelect()
        }
      },
      immediate: true,
    },
  },
  created() {
    //初始值
    this.startId = this.NODE_ID_START
  },
  methods: {
    // 关闭
    handleClose() {
      this.$emit("close")
    },
    // 保存
    async handleSave() {
      // 删除
      if (this.deleteTypeIds) {
        await deleteImgMapType({
          typeId: Array.from(new Set(this.deleteTypeIds)),
        })
      }
      // 新增
      if (this.addObject.length > 0) {
        this.addObject.map(async (item) => {
          await addImgMapType(item)
        })
      }

      // 修改
      if (this.editObject.length > 0) {
        this.editObject.map(async (item) => {
          await editImgMapType(item)
        })
      }
    },

    /**查询分类树 */
    async getImgMapTypeSelect() {
      this.isLoading = true
      const { data } = await getImgMapTypeSelect({type : this.type, remark: "1"})
      this.isLoading = false
      if (data) {
        this.setTree = data
      }
    },
    handleDelete(_node, _data) {
      //删除节点
      console.log(_node, _data) //判断是否存在子节点
      if (_data.childrenTree && _data.childrenTree.length !== 0) {
        this.$message.error("此节点有子级，不可删除！")
        return false
      } else {
        //删除操作
        let DeletOprate = () => {
          this.$nextTick(async () => {
            if (this.$refs.SlotTree) {
              await deleteImgMapType({
                typeId: _data.typeId,
              })
              this.$message.success("删除成功！")
              this.getImgMapTypeSelect()
            }
          })
        } //二次确认
        let ConfirmFun = () => {
          this.$confirm("是否删除此节点？", "提示", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              DeletOprate()
            })
            .catch(() => {})
        } //判断是否新增：新增节点直接删除，已存在的节点要二次确认
        _data[this.NODE_KEY] < this.NODE_ID_START ? DeletOprate() : ConfirmFun()
      }
    },
    async handleInput(_node, _data) {
      //修改节点
      console.log(_node, _data) //退出编辑状态
      if (_node.isEdit) {
        this.$set(_node, "isEdit", false)
        await editImgMapType({
          typeId: _data.typeId,
          typeName: _data.typeName
        })
        this.editObject[_data.typeId] = _data
      }
    },
    handleEdit(_node, _data) {
      //编辑节点
      console.log(_node, _data) //设置编辑状态
      if (!_node.isEdit) {
        this.$set(_node, "isEdit", true)
      } //输入框聚焦
      this.$nextTick(() => {
        if (this.$refs["slotTreeInput" + _data[this.NODE_KEY]]) {
          this.$refs["slotTreeInput" + _data[this.NODE_KEY]].$refs.input.focus()
        }
      })
    },
    async handleAdd(_node, _data) {
      //新增节点
      console.log(_node, _data) //判断层级
      if (_node.level >= this.MAX_LEVEL) {
        this.$message.warning("当前已达到" + this.MAX_LEVEL + "级，无法新增！")
        return false
      } //参数修改
      // let obj = JSON.parse(JSON.stringify(this.initParam)) //copy参数
      // obj.pTypeId = _data[this.NODE_KEY] //父id
      // obj[this.NODE_KEY] = --this.startId //节点id：逐次递减id //判断字段是否存在
      // if (!_data.childrenTree) {
      //   this.$set(_data, "childrenTree", [])
      // } //新增数据
      // _data.childrenTree.push(obj) //展开节点
      // this.editObject[obj.typeId] = obj
      // if (!_node.expanded) {
      //   _node.expanded = true
      // }
      await addImgMapType({
        pTypeId: _data.typeId,
        typeName: "新增节点",
        orderNum: 1,
      })
      this.getImgMapTypeSelect()
    },
    async handleAddTop() {
      //添加顶部节点
      await addImgMapType({
        pTypeId: "0",
        typeName: "新增节点",
        orderNum: 1,
      })
      this.getImgMapTypeSelect()
    },
  },
}
</script>

<style lang="scss">
/*common*/
//显示按钮
.show-btns {
  opacity: 1;
}
/*commonend*/
.comp-tree {
  width: 100%;
  max-width: 700px;
  max-height: 80vh;
  padding: 2em;
  overflow: auto;

  .el-tree-node__content {
    height: 40px;
  }

  //顶部按钮
  .comp-tr-top {
    width: 100px;
    margin-bottom: 2em;
  }
  //自定义节点
  .comp-tr-node {
    //label
    .comp-tr-node--name {
      display: inline-block;
      line-height: 40px;
      min-height: 40px;
      //新增
      &.is-new {
        font-weight: bold;
      }
    }
    //button
    .comp-tr-node--btns {
      margin-left: 20px;
      opacity: 0;
      transition: opacity 1s;
      .el-button {
        transform: scale(0.8); //缩小按钮
        & + .el-button {
          margin-left: -1px;
        }
      }
    }
  }
  //高亮显示按钮
  .is-current {
    & > .el-tree-node__content {
      .comp-tr-node--btns {
        @extend.show-btns;
      }
    }
  }
  //悬浮显示按钮
  .el-tree-node__content {
    &:hover {
      .comp-tr-node--btns {
        @extend.show-btns;
      }
    }
  }
}
</style>
